const SSO_URL = process.env.VUE_APP_API_SSO_URL
const OPEN_URL = process.env.VUE_APP_API_OPEN_URL
const FILE_URL = process.env.VUE_APP_API_FILE_URL

const api = {
  OPEN_URL,
  SSO_URL,
  apiAdviceInfo: OPEN_URL + '/apiAdviceInfo/add', // 联系我们
  loginUser: SSO_URL + '/user/login', // 登录
  SsoLogout: SSO_URL + '/user/logout', // 登出
  querySystemParamsPage: SSO_URL + '/systemParams/querySystemParamsPage', // querySystemParamsPage
  getBottomDate: SSO_URL + '/platform/getBottomDate', // 查询底部信息
  queryList: OPEN_URL + '/catalogInfo/queryList', // 查询目录
  queryListFilterByToken: OPEN_URL + '/catalogInfo/queryListFilterByToken', // 查询目录
  queryListFilterNotToken: OPEN_URL + '/catalogInfo/queryListFilterNotToken', // 查询目录
  docDetail: OPEN_URL + '/apiDocument/detailOpenQuery', // 文档详情
  docQueryList: OPEN_URL + '/apiDocument/queryList', // 查询文档
  QueryDetail: OPEN_URL + '/apiInterfaceLog/queryDetail', // 查询api文档参数详情
  docQueryListForApi: OPEN_URL + '/apiDocument/queryListForApi', // api查询文档
  QueryDocumentListForApp: OPEN_URL + '/apiDocument/queryDocumentListForApp', // api查询文档
  LoginCodeAvatar: SSO_URL + '/code/getImgCode', // 图形验证码
  LoginCheckImgCode: SSO_URL + '/code/checkImgCode', // 短信验证与校验四位验证码
  SendRetrievePassCore: SSO_URL + '/user/sendRetrievePassCore', // 图形验证码 新
  RetrievePassByPhone: SSO_URL + '/user/retrievePassByPhone', // 手机号找回密码
  RetrievePassByEmail: SSO_URL + '/user/retrievePassByEmail', // 手机号找回密码
  RendRetrievePassEmail: SSO_URL + '/user/sendRetrievePassEmail', // 邮箱找回密码
  NoticeThirdSystem: SSO_URL + '/serviceInfo/noticeThirdSystemClearCache', // 通知第三方清除缓存
  TransformLogin: SSO_URL + '/user/transformLogin', // 跳转用户中心登录状态转换
  AddOrEditUserViewField: SSO_URL + '/userViewField/addOrEditUserViewField', // 新增或编辑展示字段
  QueryUserViewField: SSO_URL + '/userViewField/queryUserViewField', // 展示字段查询

  AppqueryList: OPEN_URL + '/apiAppInfo/queryList', // 应用列表
  AppqueryList1: '/apiAppInfo/queryList', // 应用列表
  UpdateAppEffective: OPEN_URL + '/apiAppInfo/updateAppEffective', // app作废
  viewApp: OPEN_URL + '/apiAppInfo/viewApp', // app作废
  AppResetKey: OPEN_URL + '/apiAppInfo/appResetKey', // app重置密钥
  BannerQueryList: OPEN_URL + '/banner/queryList', // 首页海报
  QueryListForApp: OPEN_URL + '/apiDocument/queryListForApp', // 查询api
  AppAdd: OPEN_URL + '/apiAppInfo/add', // 新增
  UpdateApp: OPEN_URL + '/apiAppInfo/updateAppInfo', // 新增
  QueryAppInfoByParam: OPEN_URL + '/apiAppInfo/queryAppInfoByParam', // 查询应用详细信息
  SystemList: OPEN_URL + '/apiThirdSystem/queryList', // 查询平台
  SsogetChilldList: SSO_URL + '/subject/getSubjectSubAcconutList', // 查询平台
  SsoGetCityInfo: SSO_URL + '/city/getCityInfo', // 省市区
  SsoSetSubject: SSO_URL + '/subject/authenticationSubject', // 上传公司信息
  SsoGetUserInfo: SSO_URL + '/user/getUserInfo', // 查询主体subjectid
  SsoUserChooseSubject: SSO_URL + '/subject/userChooseSubject', // 切换主体
  SsoGetSubjectAuthentication: SSO_URL + '/subject/getSubjectAuthentication', // 切换主体
  SsoGetSubjectAuthentications: SSO_URL + '/subject/getSubjectAuthentications', // 资质认证列表
  GetPersonalUserSub: SSO_URL + '/user/getPersonalUserSub', // 切换主体
  SsoGetDeactivateStaff: SSO_URL + '/subject/deactivateStaff', // 切换主体
  SsoGetUserEditRoleMenuBySys: SSO_URL + '/role/getUserEditRoleMenuBySys', // 获取子账号信息
  InterfacequeryList: OPEN_URL + '/apiInterfaceLog/queryList', // 接口日志
  AddSysSubAccount: SSO_URL + '/user/addSysSubAccount', // 获取子账号信息
  GetAnnouncementYhEjectDetail: SSO_URL + '/announcementGroup/getAnnouncementYhEjectDetail',
  UpLoadImg: FILE_URL + '/upload/uploadImg?systemCode=openapi', // 上传文件
  downloadImg: FILE_URL + '/upload/download',
  Register: SSO_URL + '/user/register', // 注册
  SsogetCityInfoByAreaCode: SSO_URL + '/city/getCityInfoByAreaCode', // 注册
  SsogetUserRoleMenu: SSO_URL + '/role/getUserRoleMenu', // 获取
  ForgePassword: SSO_URL + '/auth/forge-password',
  twoStepCode: SSO_URL + '/auth/2step-code',
  SendSms: SSO_URL + '/account/sms',
  SendSmsErr: SSO_URL + '/account/sms_err',
  // get my info
  UserInfo: SSO_URL + '/user/info',
  GetSubjectList: SSO_URL + '/subject/getSubjectList', // 企业主体列表
  CreateOpenApiCompany: SSO_URL + '/subject/createOpenApiCompany', // 去认证
  QueryAppAuthSubject: OPEN_URL + '/appAuthInterface/queryAppAuthSubject', // 应用授权获取企业列表
  QueryAppAuthOrUnAuthInfo: OPEN_URL + '/appAuthInterface/queryAppAuthOrUnAuthInfo', // 应用授权获取企业列表
  QueryAuthService: OPEN_URL + '/appAuthInterface/queryAuthService', // 查询主体授权应用的服务
  QueryOwnerAppAuthInterface: OPEN_URL + '/appAuthInterface/queryOwnerAppAuthInterface',
  QueryBaseAuthForApp: OPEN_URL + '/apiDocument/queryBaseAuthForApp',
  // 国际区号
  PhoneCodeInterface: SSO_URL + '/ThirdInterface/phoneCodeInterface',
  // 定位
  LocationToAdress: SSO_URL + '/lbs/locationToAdress',
  // 帮助中心   预约演示
  ReservationShow: SSO_URL + '/websiteLink/reservationShow',
  GetEosBaseInfo: SSO_URL + '/websiteLink/getEosBaseInfo',
  GetOptLog: SSO_URL + '/optLog/queryList', // 操作日志
  GetOptLog1: '/optLog/queryList', // 操作日志
  QueryDownload: SSO_URL + '/optLog/queryDownload', // 操作日志操作内容下载
  GetSubSimpleUserList: SSO_URL + '/user/getSubSimpleUserList', // 账号管理列表 - 简化版
  QuerySdkFileInfo: SSO_URL + '/sdkFile/querySdkFileInfo', // 查询SDK文件信息
  QueryPageBindDocument: SSO_URL + '/pageDocumentRelation/queryPageBindDocument', // 获取详细页面信息
  QueryApiNum: OPEN_URL + '/apiInterfaceLog/queryApiNum',
  QuerySystemExtListForSub: SSO_URL + '/subjectServiceSystemExt/querySystemExtListForSub' // （新） 查询企业单服务多系统列表数据
}
export default api
